import { render } from "./ForbiddenAccess.vue?vue&type=template&id=e4d73498&scoped=true&ts=true"
import script from "./ForbiddenAccess.vue?vue&type=script&lang=ts"
export * from "./ForbiddenAccess.vue?vue&type=script&lang=ts"

import "./ForbiddenAccess.vue?vue&type=style&index=0&id=e4d73498&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d73498"]])

export default __exports__